import styled from "styled-components";
import theme from "../../../../Styles/theme";

interface ContainerProps {
  myMessage: boolean;
}

export const Container = styled.div<ContainerProps>`
  width: 100%;
  display: flex;
  justify-content: ${({ myMessage }) =>
    myMessage ? "flex-end" : "flex-start"};
  padding: 4px 0;
`;

export const ContainerMessage = styled.div<ContainerProps>`
  background-color: ${({ myMessage }) =>
    myMessage ? "#D6E4FF" : theme.colors.light};
  color: ${({ myMessage }) =>
    myMessage ? theme.colors.dark : theme.colors.dark};
  max-width: 80%;
  min-width: 40%;
  border-radius: 0.25rem;
  margin-bottom: 1vh;
  padding: 0.8vh 1.5vw;
  display: flex;
  flex-direction: column;
  text-align: justify;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
`;



export const SpanDate = styled.div`
  font-size: max(8px, 0.8vw);
  color: ${theme.colors.darkGrey};
  text-align: right;
  width: 100%;
  margin-top: 4px;
`;

export const Imagem = styled.img`
  width: 100%;
  max-height: 200px;
  object-fit: cover;
  margin-top: 8px;
  border-radius: 5px;
  cursor: pointer;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.02);
  }
`;

export const ButtonPdfView = styled.button`
  background: ${theme.colors.primary};
  border: none;
  color: white;
  padding: 6px 10px;
  border-radius: 5px;
  margin-top: 8px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: background-color 0.2s;

  &:hover {
    background-color: ${theme.colors.primaryDark};
  }
`;
